import Inspector from './inspector';
const { InnerBlocks } = wp.blockEditor;

const Edit = ({ attributes, setAttributes }) => {
  const { loop, cardSpace, containerized, centered, margin, hasFakeItem } =
    attributes;

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />
      <section className={`SwiperGeral ${margin}`}>
        <div
          className={`SwiperGeral__content editor ${
            containerized ? 'Container' : ''
          }`}
        >
          <div
            className={`SwiperGeral__slider ${loop ? 'hasLoop' : ''} ${
              centered ? 'isCentered' : ''
            }`}
            card-space={cardSpace}
          >
            <div className="swiper-wrapper">
              {hasFakeItem && <div className="fake-item"></div>}

              <InnerBlocks />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Edit;
